import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';

import { Col, css, Grid, Row, styled, up } from '@smooth-ui/core-sc';
import Button from '_platform/src/components/Button/Button';

import NotFoundGraphic from './images/404-error-icons.svg';

const PageContainer = styled.div`
  button {
    color: #fff;
    min-width: 180px;
    padding: 10px 40px;
  }
`;

const StyledNotFoundImage = styled.p`
  padding-bottom: 2rem;
  padding-top: 2rem;
  text-align: center;
  img {
    height: 183px;
    height: auto;
    width: 174px;
    ${up(
      'md',
      css`
        height: 366px;
        height: auto;
        width: 550px;
      `
    )};
  }
`;

const NotFoundPage = ({ location }) => (
  <PageContainer>
    <Helmet>
      {/* Note: title must contain '404' in order for react-snap to render the error page properly */}
      {/* https://github.com/stereobooster/react-snap/issues/91 */}
      <title>Page not found (404)</title>
      <meta name="prerender-status-code" content="404" />
    </Helmet>
    <Grid className="spacer">
      <Row justifyContent="center">
        <Col sm={10} md={6}>
          <h1 className="text--center text--primary">404 Error</h1>
          <p className="text--center text--large spacer--bottom">
            <strong>
              Sorry looks like we are having a bit of trouble finding what
              you’re looking for!
            </strong>
            <br />
            Follow these guys back home and give it another go.
          </p>
          <StyledNotFoundImage>
            <img src={NotFoundGraphic} alt="Panicking website user" />
          </StyledNotFoundImage>
          <p className="text--center">
            <Link as="button" to="/" title="Go back to the Home page">
              <Button>
                <strong>Back to home</strong>
              </Button>
            </Link>
          </p>
        </Col>
      </Row>
    </Grid>
  </PageContainer>
);

NotFoundPage.propTypes = {
  location: PropTypes.object,
};

NotFoundPage.defaultProps = {
  location: {},
};

export default NotFoundPage;
